import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
import api from "./api.js";

export default async function changeOrderToInTransit(orderId) {
  const Authorization = "bearer " + localStorage.getItem("token");
  const rider_id = localStorage.getItem("rider_id");
  const resp = await fetch(`${API_URL}rest/V1/rider/setOrderInTransit`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify({
      orderId: orderId,
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("changeOrderToInTransitAPI", data);
      return data;
      //   api.callShippingJobs(component, trip_id);
    });

  return resp;
}



// WEBPACK FOOTER //
// ./src/utility/api/changeOrderToInTransit.js